import { IHandler } from "@/faq/IHandler";
import { FilterOptions } from "@/filters/options/FilterOptions";
import { FilterSelectionState } from "@/filters/selection/FilterSelectionState";
import { SeoInfoBase } from "@/seo/SeoInfoBase";
import { IStaticContent } from "./IStaticContent";
import { SortingState } from "@/sorting/SortingState";

export abstract class StaticContentHandler extends SeoInfoBase implements IHandler {

	private nextHandler?: IHandler;
	private id: string | null;

	public constructor(filterOptions: FilterOptions, id: string | null) {
		super(filterOptions);
		this.id = id;
	}

	public async handle(filterState: FilterSelectionState, sortState: SortingState): Promise<IStaticContent> {
		if (await this.canHandle(filterState, sortState, this.id)) {
			return this.selfHandle();
		}

		if (!this.nextHandler) {
			throw new Error("No handler found to handle the request.");
		}

		return this.nextHandler.handle(filterState, sortState);
	}

	public setNext(handler: IHandler): IHandler {
		this.nextHandler = handler;

		return this.nextHandler;
	}

	protected abstract canHandle(filterState: FilterSelectionState, sortState: SortingState, id: string | null): Promise<boolean>;

	protected abstract selfHandle(): Promise<IStaticContent>;
}
